(() => {
  const MOBILE_QUERY = '(max-width: 749px)';

  class RingStickyAddToCart {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.mediaQuery = window.matchMedia(MOBILE_QUERY);

      this.stickyButton = root.querySelector('[data-ring-sticky-button]');
      this.stickyButtonText = root.querySelector('[data-ring-sticky-button-text]');
      this.stickyPrice = root.querySelector('[data-ring-sticky-price]');

      this.refreshReferences();

      if (!this.mainButton || !this.stickyButton) return;

      this.mainButtonVisible = true;

      this.stickyButton.addEventListener('click', () => {
        this.refreshReferences();

        if (!this.mainButton || this.mainButton.disabled) return;

        this.mainButton.click();
      });

      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          this.mainButtonVisible = entries[0]?.isIntersecting ?? true;
          this.updateVisibility();
        },
        {
          threshold: 0.15,
        }
      );

      this.intersectionObserver.observe(this.mainButton);

      this.mutationObserver = new MutationObserver(() => this.sync());

      this.mutationObserver.observe(this.mainButton, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled'],
      });

      if (this.mainPrice) {
        this.mutationObserver.observe(this.mainPrice, {
          childList: true,
          subtree: true,
        });
      }

      const mediaChangeHandler = () => this.updateVisibility();

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', mediaChangeHandler);
      } else {
        this.mediaQuery.addListener(mediaChangeHandler);
      }

      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined'
      ) {
        this.unsubscribeVariant = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event?.data?.sectionId !== this.sectionId) return;

            window.requestAnimationFrame(() => this.sync());
          }
        );
      }

      this.sync();
      this.updateVisibility();
    }

    refreshReferences() {
      this.mainForm = document.getElementById(
        `product-form-${this.sectionId}`
      );

      this.mainButton = this.mainForm?.querySelector('[name="add"]');

      this.mainPrice = document.getElementById(
        `price-${this.sectionId}`
      );
    }

    getCurrentPriceText() {
      if (!this.mainPrice) return '';

      const sale = this.mainPrice.querySelector(
        '.price--on-sale .price-item--sale'
      );

      const regular = this.mainPrice.querySelector(
        '.price__regular .price-item--regular'
      );

      const fallback = this.mainPrice.querySelector('.price-item');

      return (
        (sale || regular || fallback)
          ?.textContent
          ?.replace(/\s+/g, ' ')
          .trim() || ''
      );
    }

    sync() {
      this.refreshReferences();

      if (!this.mainButton) return;

      this.stickyButton.disabled = this.mainButton.disabled;

      const text = this.mainButton
        .querySelector('span')
        ?.textContent
        ?.replace(/\s+/g, ' ')
        .trim();

      if (text && this.stickyButtonText) {
        this.stickyButtonText.textContent = text;
      }

      const price = this.getCurrentPriceText();

      if (price && this.stickyPrice) {
        this.stickyPrice.textContent = price;
      }
    }

    updateVisibility() {
      this.root.hidden = !(
        this.mediaQuery.matches &&
        !this.mainButtonVisible
      );
    }
  }

  class RingSocialShare {
    constructor(root) {
      this.root = root;
      this.copyButton = root.querySelector('[data-ring-copy-link]');
      this.status = root.querySelector('[data-ring-share-status]');

      if (!this.copyButton) return;

      this.copyButton.addEventListener('click', () => {
        this.copyLink();
      });
    }

    async copyLink() {
      const url = this.copyButton.dataset.shareUrl;

      if (!url) return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          this.fallbackCopy(url);
        }

        this.showStatus('Link copied');
      } catch (error) {
        try {
          this.fallbackCopy(url);
          this.showStatus('Link copied');
        } catch (fallbackError) {
          this.showStatus('Unable to copy link');
        }
      }
    }

    fallbackCopy(text) {
      const textarea = document.createElement('textarea');

      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);

      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      const copied = document.execCommand('copy');

      textarea.remove();

      if (!copied) {
        throw new Error('Copy command failed');
      }
    }

    showStatus(message) {
      if (!this.status) return;

      this.status.textContent = message;
      this.status.hidden = false;

      window.clearTimeout(this.statusTimer);

      this.statusTimer = window.setTimeout(() => {
        this.status.hidden = true;
      }, 2500);
    }
  }

  const initStickyAddToCart = () => {
    document
      .querySelectorAll('[data-ring-sticky-atc]')
      .forEach((root) => {
        if (root.dataset.ringStickyInitialized === 'true') return;

        root.dataset.ringStickyInitialized = 'true';

        new RingStickyAddToCart(root);
      });
  };

  const initSocialShare = () => {
    document
      .querySelectorAll('.ring-social-share')
      .forEach((root) => {
        if (root.dataset.ringShareInitialized === 'true') return;

        root.dataset.ringShareInitialized = 'true';

        new RingSocialShare(root);
      });
  };

  const init = () => {
    initStickyAddToCart();
    initSocialShare();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true,
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();